// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.thetatoken",
    name: "Theta Wallet",
    homepage: "https://www.thetatoken.org/wallet",
    image_id: "d4afb810-5925-4f00-4ebb-d180fcf29000",
    app: {
        browser: "https://wallet.thetatoken.org",
        ios: "https://apps.apple.com/app/theta-wallet/id1451094550",
        android: "https://play.google.com/store/apps/details?id=org.theta.wallet&pli=1",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "wc://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map